// extracted by mini-css-extract-plugin
export default {"page":"tags_page__Uov0w","container":"tags_container__DLDpf"};